/**
 * @file   src\components\Onboarding\UserRegister\EmailResentModal.js
 * @brief  This file is responsible for email resent modal
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import { sendEmailContactSupport } from "../../../helpers/common";

const EmailResentModal = (props) => {
  const { email } = props;
  return (
    <Modal
      show
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="pt-32 pb-32">
        <h2 className="text-center">Email Resent</h2>

        <Row>
          <Col xl={12}>
            <p className="mb-2 text-center">
              We've sent a {props.login ? "login" : "verification"} link to{" "}
              <strong>{email}</strong>
            </p>
            <p className="text-center">
              Still having trouble?{" "}
              <strong>
                <a href="#" onClick={() => sendEmailContactSupport("Message")}>
                  Contact support.
                </a>
              </strong>
            </p>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default EmailResentModal;
